import { AlertCircle } from "lucide-react";

interface ApiBannerProps {
    error: Error | unknown;
    onRetry?: () => void;
    children?: React.ReactNode;
}

export function ApiBanner({ error, onRetry, children }: ApiBannerProps) {
    const message =
        error instanceof Error
            ? error.message
            : typeof error === "string"
              ? error
              : "Falha desconhecida";
    return (
        <div className="bg-rose-50 border border-rose-100 rounded-lg p-4 flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-rose-900">
                    Erro ao carregar dados
                </p>
                <p className="text-xs text-rose-700 mt-0.5 break-all">
                    {message}
                </p>
                {children}
            </div>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="text-xs font-medium text-rose-700 hover:text-rose-900 px-3 py-1.5 rounded-lg border border-rose-200 hover:bg-rose-100 shrink-0"
                >
                    Tentar novamente
                </button>
            )}
        </div>
    );
}
